/** Flow Stakeholders static UI routes (Management + Management2). */

import { MANAGEMENT2_FLOW_STAKEHOLDERS_LIST_PATH } from './management2Nav';

export const FLOW_STAKEHOLDERS_LIST_PATH = '/vms/flow-stakeholders';

export function flowStakeholdersDetailPath(
  initiationId: string | number,
  useManagement2Route = false,
): string {
  const id = encodeURIComponent(String(initiationId));
  return useManagement2Route
    ? `${MANAGEMENT2_FLOW_STAKEHOLDERS_LIST_PATH}/${id}`
    : `${FLOW_STAKEHOLDERS_LIST_PATH}/${id}`;
}

export function flowStakeholdersListPathFromLocation(pathname: string): string {
  return pathname.includes('/management2/flow-stakeholders')
    ? MANAGEMENT2_FLOW_STAKEHOLDERS_LIST_PATH
    : FLOW_STAKEHOLDERS_LIST_PATH;
}

export function isFlowStakeholdersStaticPath(pathname: string): boolean {
  return (
    pathname === FLOW_STAKEHOLDERS_LIST_PATH ||
    pathname === `${FLOW_STAKEHOLDERS_LIST_PATH}/legacy` ||
    /^\/vms\/flow-stakeholders\/[^/]+$/.test(pathname) ||
    pathname === MANAGEMENT2_FLOW_STAKEHOLDERS_LIST_PATH ||
    /^\/vms\/management2\/flow-stakeholders\/[^/]+$/.test(pathname)
  );
}
